import input from 'src/helpers/input'

/**
 * InputMixin is to be implemented
 * onto components which use Input.
 *
 * It essentially groups all the similar props and methods into one file
 */
export default {
  mixins: [input],
  props: {
    modelValue: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    borderless: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    separator: {
      type: Boolean,
      default: false
    },
    showSelection: {
      type: Boolean,
      default: true
    }
  },
  emits: ['clickedResult', 'removedResult', 'update:modelValue'],
  methods: {
    onClickedResult (val, newModel) {
      this.$emit('clickedResult', val, newModel)
    },
    onRemovedResult (val) {
      this.$emit('removedResult', val)
    },
    onInput (val) {
      this.$emit('update:modelValue', val)
    }
  }
}
